import { Component, forwardRef, HostListener, Input, OnChanges, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { InputBaseReactComponent } from './../input-base-react/input-base-react.component';


@Component({
  selector: 'app-input-integer-react',
  templateUrl: './input-integer-react.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputIntegerReactComponent),
      multi: true
    }
  ]
})

export class InputIntegerReactComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit, OnChanges {

  protected numericSpan?: string = undefined;
  @Input() public min?: number = null;
  @Input() public max?: number = null;

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.loadValidators();
    this.setAndUpdateValidators();
  }

  // tslint:disable-next-line:cyclomatic-complexity
  @HostListener('keydown', ['$event']) onKeyDown(event): any {
    const e = event as KeyboardEvent;
    if (
      // allow: n
      (e.code === 'KeyN') ||
      // allow: Esc
      (e.code === 'Escape') ||
      // allow: Tab
      (e.code === 'Tab') ||
      // allow: Backspace
      (e.code === 'Backspace') ||
      // allow: Enter
      (e.code === 'Enter') ||
      // allow: Ctrl+A
      (e.code === 'KeyA' && (e.ctrlKey || e.metaKey)) ||
      // allow: Ctrl+C
      (e.code === 'KeyC' && (e.ctrlKey || e.metaKey)) ||
      // allow: Ctrl+V
      (e.code === 'KeyV' && (e.ctrlKey || e.metaKey)) ||
      // allow: Ctrl+X
      (e.code === 'KeyX' && (e.ctrlKey || e.metaKey)) ||
      // allow: home, end, left, right
      (e.code === 'ArrowRight' || e.code === 'ArrowLeft' || e.code === 'Home' || e.code === 'End')) {
      // let it happen, don't do anything
      return;
    }

    // ensure that it is a number and stop the keypress
    // tslint:disable-next-line: deprecation
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  }

  // chama método ngOnChanges da classe base e efetua o recarregamento de validadores.
  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges(): void {
    super.ngOnChanges();
    this.loadValidators();
    this.setAndUpdateValidators();
  }

  private loadValidators(): void {
    this.insertValidator(Validators.pattern('^[0-9 \-\']+'));
    if (this.max) {
      this.insertValidator(Validators.max(this.max));
    }
    if (this.min) {
      this.insertValidator(Validators.min(this.min));
    }
  }
}
